import CityPageTemplate from "../city-template/CityPageTemplate";
import { cumberlandConfig } from "./data";

export default function CumberlandPage() {
  return <CityPageTemplate config={cumberlandConfig} />;
}